import RequestBasicAuthen from "drupal-vuejs/src/App/BasicAuthentification/RequestBasicAuthen";
export default {
  ...RequestBasicAuthen,
  TestDomain: "http://gestiontaches.kksa",
  baseUrl: "https://gestion-taches-vps.habeuk.com",
  debug: false
};
